import React, { useEffect, useState, useRef } from 'react'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { Sidebar } from './sidebar'
import { Menu, MenuItem, Select } from '@mui/material'
import { CollaboratorList } from './users.component'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
export const TagRecap = ({ name, surface, hotelImage, hotel_total, tags, type, blacklist = [], onChange }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false)

    const handleOpenSidebar = () => {
        setIsSidebarOpen(true)
    }

    const handleCloseSidebar = () => {
        setIsSidebarOpen(false)
    }

    const containerStyle = {
        padding: '10px',
        paddingLeft: '0px',
        position: 'relative',
    }

    const iconStyle = {
        cursor: 'pointer',
    }

    return (
        <div style={containerStyle}>
            <div style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                <div>
                    <Select
                        value={name}
                        style={{ background: 'white' }}
                        onChange={(e) => {
                            onChange(name, e.target.value)
                        }}
                    >
                        {tags
                            ?.filter((el) => el?.type == type)
                            ?.map((el, index) => {
                                return (
                                    <MenuItem key={index} value={el?.name} disabled={blacklist?.indexOf(el?.name) > -1}>
                                        {el?.name?.toUpperCase()}
                                    </MenuItem>
                                )
                            })}
                    </Select>
                </div>
                <div style={{ marginLeft: 5, cursor: 'pointer' }} onClick={handleOpenSidebar}>
                    <OpenInNewIcon style={iconStyle} />
                </div>
            </div>

            {isSidebarOpen ? (
                <Sidebar isOpen={isSidebarOpen} onClose={handleCloseSidebar}>
                    <div
                        style={{
                            maxHeight: '100vh',
                            overflowY: 'auto',
                            padding: '20px',
                        }}
                    >
                        <strong>{name?.toUpperCase()}</strong>
                        <img
                            src={
                                hotelImage ||
                                'https://images.unsplash.com/photo-1445991842772-097fea258e7b?q=80&w=2970&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
                            }
                            alt="Hotel"
                            style={{ width: '100%', height: 'auto', marginTop: '20px' }}
                        />
                        <p style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <strong>Collaborateurs</strong>
                            <AddCircleOutlineIcon style={{ cursor: 'pointer' }} />
                        </p>
                        <CollaboratorList />
                        <div style={{ marginTop: '20px' }}>
                            <p>
                                <strong>Surface:</strong> {surface} m²
                            </p>
                            <p>
                                <strong>Total Hotels:</strong> {hotel_total}
                            </p>
                            <p>
                                <strong>Headquarters Surface Area:</strong> {surface} m²
                            </p>
                            <p>
                                <strong>Total Employees:</strong> 22
                            </p>
                            <p>
                                <strong>Location:</strong> Lorem Ipsum, Dolor Sit Amet
                            </p>
                            <p>
                                <strong>Description:</strong> This is a leading investment bank providing a wide range
                                of financial services including investment banking, securities, wealth management, and
                                investment management. The bank is renowned for its expertise in mergers and
                                acquisitions, capital markets, and risk management.
                            </p>
                            <p>
                                <strong>Services:</strong>
                            </p>
                            <ul>
                                <li>Investment Banking</li>
                                <li>Wealth Management</li>
                                <li>Securities Trading</li>
                                <li>Capital Markets</li>
                                <li>Risk Management</li>
                            </ul>
                        </div>
                    </div>
                </Sidebar>
            ) : null}
        </div>
    )
}
